import injectMultipleBanners from './inject-multiple-banners';

export default injectMultipleBanners;
